import { render, staticRenderFns } from "./PCIFail.vue?vue&type=template&id=064fb1c2&scoped=true"
import script from "./PCIFail.vue?vue&type=script&lang=js"
export * from "./PCIFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fb1c2",
  null
  
)

export default component.exports